document.addEventListener('DOMContentLoaded', function () {

  let previousActiveElement = null;
  let sizeGuideLoaded = false;


  /* ================================
     GET MODAL
  ================================= */

  function getModal() {
    return document.querySelector('[data-size-guide-modal]');
  }


  /* ================================
     GET CONTENT
  ================================= */

  function getContent() {
    return document.querySelector('[data-size-guide-content]');
  }


  /* ================================
     LOAD SIZE GUIDE
  ================================= */

  function loadSizeGuide() {

    const content = getContent();

    if (!content || sizeGuideLoaded) return;

    content.innerHTML = `
      <div class="size-guide-modal__loading">
        Loading...
      </div>
    `;

    fetch('/pages/size-guide')
      .then(function (response) {

        if (!response.ok) {
          throw new Error('Unable to load Size Guide');
        }

        return response.text();
      })
      .then(function (html) {

        const parser = new DOMParser();

        const documentHTML = parser.parseFromString(
          html,
          'text/html'
        );

        const sizeGuideContent =
          documentHTML.querySelector('.size-guide-page-content');

        if (!sizeGuideContent) {
          throw new Error('Size Guide content not found');
        }

        content.innerHTML = sizeGuideContent.innerHTML;

        sizeGuideLoaded = true;
      })
      .catch(function (error) {

        console.error('Size Guide:', error);

        content.innerHTML = `
          <p class="size-guide-modal__error">
            Unable to load the Size Guide. Please try again.
          </p>
        `;
      });
  }


  /* ================================
     OPEN MODAL
  ================================= */

  function openModal() {

    const modal = getModal();

    if (!modal) return;

    previousActiveElement = document.activeElement;

    loadSizeGuide();

    modal.classList.add('is-open');

    modal.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement.classList.add(
      'size-guide-open'
    );

    document.body.classList.add(
      'size-guide-open'
    );

    const closeButton =
      modal.querySelector('.size-guide-modal__close');

    if (closeButton) {
      closeButton.focus();
    }
  }


  /* ================================
     CLOSE MODAL
  ================================= */

  function closeModal() {

    const modal = getModal();

    if (!modal) return;

    modal.classList.remove('is-open');

    modal.setAttribute(
      'aria-hidden',
      'true'
    );

    document.documentElement.classList.remove(
      'size-guide-open'
    );

    document.body.classList.remove(
      'size-guide-open'
    );

    if (
      previousActiveElement &&
      document.body.contains(previousActiveElement)
    ) {
      previousActiveElement.focus();
    }
  }


  /* ================================
     CLICK HANDLER
     
     EVENT DELEGATION
  ================================= */

  document.addEventListener('click', function (event) {

    const trigger =
      event.target.closest('[data-size-guide-trigger]');

    if (trigger) {

      event.preventDefault();

      openModal();

      return;
    }


    const closeButton =
      event.target.closest('[data-size-guide-close]');

    if (closeButton) {

      event.preventDefault();

      closeModal();

      return;
    }

  });


  /* ================================
     ESC KEY
  ================================= */

  document.addEventListener('keydown', function (event) {

    if (event.key !== 'Escape') return;

    const modal = getModal();

    if (
      modal &&
      modal.classList.contains('is-open')
    ) {
      closeModal();
    }

  });

});